import Layout from './Layout'

export default Layout



// WEBPACK FOOTER //
// ./src/features/Contacts/components/Layout/index.js